// extracted by mini-css-extract-plugin
export var aircallIframe = "_jq-3";
export var fabContainer = "_jq-5";
export var fabRinging = "_jq-6";
export var loadingOverlay = "_jq-4";
export var pulse = "_jq-7";
export var widgetContent = "_jq-2";
export var widgetPanel = "_jq-0";
export var widgetPanelExpanded = "_jq-1";